export type PlatformStatus = 'live' | 'building' | 'exploring';

const STATUS_STYLES: Record<
  PlatformStatus,
  { label: string; bg: string; color: string; dot: string }
> = {
  // Live = teal/green (matches the 'free'/success tokens used elsewhere)
  live: { label: 'Live', bg: '#E7F6ED', color: '#0F7A43', dot: '#0F9D58' },
  // Building = amber (matches the 'licensed' token)
  building: { label: 'Building', bg: '#FEF3C7', color: '#B45309', dot: '#D97706' },
  // Exploring = grey
  exploring: { label: 'Exploring', bg: '#F1F3F5', color: '#4B5563', dot: '#9CA3AF' },
};

interface StatusBadgeProps {
  status: PlatformStatus;
  /** Override the default label ("Live" / "Building" / "Exploring"). */
  label?: string;
  className?: string;
}

export function StatusBadge({ status, label, className }: StatusBadgeProps) {
  const style = STATUS_STYLES[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${
        className ?? ''
      }`}
      style={{ backgroundColor: style.bg, color: style.color }}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: style.dot }}
        aria-hidden
      />
      {label ?? style.label}
    </span>
  );
}
